import React from 'react';

const FooterComponent = () => {
    const codigoPromomatts = 'CLA24DI00382';
    return (
        <footer className="bg-transparent text-white text-xs py-2 px-4 flex justify-between items-center w-full">
            <div className="max-w-screen-lg mx-auto flex flex-col md:flex-row items-center justify-between w-full">
                <p className="text-dark md:mr-4 text-justify mt-2" style={{ fontFamily: "arial" }}>
                    Novo Nordisk® es una marca registrada propiedad de Novo Nordisk A/S. Material revisado y aprobado por la Dirección de Asuntos Médicos y Regulatorios de Novo Nordisk®. Para uso exclusivo del
                    profesional de la salud y en Guatemala es para uso exclusivo del profesional médico. Si tiene alguna solicitud de información médica escríbanos a medicalinfo_clat@novonordisk.com <strong>{codigoPromomatts}</strong>
                </p>
                <div className="mt-2 md:mt-0">
                    <img src="./logo-novo-blue.png" alt="Novo Nordisk logo" className="w-40 h-38 md:h-10" />
                </div>
            </div>
        </footer>
    );
};

export default FooterComponent;
